import kvbImage from '../images/karkidaka-vavubali-feature.webp';

const KarkidakaVavuBali = () => {
    return (
        <>
            <div className='container mx-auto'>
                <section className='py-5 px-4 flex flex-col-reverse lg:flex-row items-center justify-between'>
                    <div className="lg:w-1/2 text-center lg:text-left mt-5 mr-2">
                        <h1 className='text-xl lg:text-2xl font-bold text-gray-800 mb-6'>Karkidaka Vavu Bali</h1>
                        <p>Karkidaka Vavu (Malayalam: കർക്കിടക വാവ്) or 'Karkidaka Vavu Bali'
                            is the name for the rituals performed by the Hindus in the state
                            of Kerala for their deceased ancestors. This day is also known as
                            'Vavu Bali' and is held in the month of 'Karkidakam' in the
                            Malayalam calendar. If one follows the English calendar, the date
                            falls in July to August.</p>
                        <p className='mt-5'>The ceremonies for deceased grandparents, parents, siblings,
                            children, and relatives are performed on 'Karutavavu' (new moon)
                            in the month of Karkidaka. The 'Shraddham' rituals must be done
                            on river banks or seashore. In Kerala, the 'Shraddh' rituals
                            done for the soul of the dead are known as 'Bali' and the new
                            moon day or 'Amavasi' is referred to as 'Vavu', hence the name
                            'Vavu Bali'.</p>
                        <p className='mt-5'>This year Karkidaka Vavu Bali is on July 24, Thursday.</p>
                        <p className='mt-5'>Rama Darma Prachara Sabha will be providing the Ritual Service at the Banks of Kapra. Those who would like to take the services should book the Time Slots well in advance through our Booking App. Please click below to proceed with booking for the event.</p>
                        <div className='mt-8'>
                            <a href='https://app.ramadharmapracharasabha.com' className="bg-orange-500 text-white px-6 py-3 rounded-lg hover:bg-orange-400 transition mt-5">
                                Book Event
                            </a></div>
                    </div>
                    <div className="lg:w-1/2">
                        <img
                            src={kvbImage}
                            alt="Karkidaka Vavubali"
                            className="rounded-lg shadow-lg object-cover"
                        />
                    </div>
                </section>
                <section className='py-5 px-4 flex flex-col-reverse lg:flex-row items-center justify-between'>
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/-6jV3Zt8tio?si=W6ql2hpyu5r8YH0o" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </section>
            </div>
        </>
    );
};

export default KarkidakaVavuBali;